/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Facts_Source_LabelInputs */

const en_gc_resources_facts_source_label = /** @type {(inputs: Gc_Resources_Facts_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT / Apache 2.0`)
};

const zh_gc_resources_facts_source_label = /** @type {(inputs: Gc_Resources_Facts_Source_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MIT / Apache 2.0`)
};

/**
* | output |
* | --- |
* | "MIT / Apache 2.0" |
*
* @param {Gc_Resources_Facts_Source_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_facts_source_label = /** @type {((inputs?: Gc_Resources_Facts_Source_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Facts_Source_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_facts_source_label(inputs)
	return zh_gc_resources_facts_source_label(inputs)
});
export { gc_resources_facts_source_label as "gc.resources.facts.source.label" }